import DocumentHeader from '@/components/DocumentHeader';
import { OneColumn } from '@/components/Layout';
import { Grid } from '@simplywallst/ui-core';
import { ReactNode } from 'react';
import { NarrativeSkeletonLoader } from './NarrativeSkeletonLoader';
import { NarrativeGenericError } from './NarrativeGenericError';

type Props = {
  title: string;
  children: ReactNode;
  isLoading: boolean;
  error: string | boolean | undefined;
};

export const NarrativeLayout = ({
  title,
  children,
  isLoading,
  error,
}: Props) => {
  const renderContent = () => {
    if (isLoading) {
      return <NarrativeSkeletonLoader />;
    }

    if (error) {
      return <NarrativeGenericError>{error}</NarrativeGenericError>;
    }

    return children;
  };
  return (
    <OneColumn>
      <DocumentHeader title={title} />

      <Grid gap="16px" paddingTop="x2">
        {renderContent()}
      </Grid>
    </OneColumn>
  );
};
